module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "stdapplinf-detail-pg9"
    }
  }, [_c('hrms-table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.data
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-md-offset-2"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['70']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.setDateOutput(_vm.dteupd)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-md-offset-1"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['80']))]), _vm._v(" "), _c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.coduser))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7580738e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stdapplinf/stdapplinfDetailPg9.vue
// module id = 3874
// module chunks = 1